const GET_BLACK_LIST_EMAIL = 'GET_BLACK_LIST_EMAIL';

export default GET_BLACK_LIST_EMAIL;
